import * as v from 'valibot';
import { PARTICIPANT_ROLE } from '../constants';

export const HumanParticipantSchema = v.object({
  name: v.string(),
  pid: v.string(),
  ruid: v.string(),
  role: v.picklist(Object.values(PARTICIPANT_ROLE)),
  uid: v.optional(v.string()),
  avatar: v.optional(v.string()),
  isLocal: v.boolean(),
  sources: v.optional(
    v.map(
      v.union([v.literal('video'), v.literal('audio')]),
      v.map(v.string(), v.any()),
    ),
  ),
  type: v.literal('human'),
});

export type HumanParticipant = v.InferInput<typeof HumanParticipantSchema>;
